import { render } from "./RememberPasswordComponent.vue?vue&type=template&id=e7b82eb8"
import script from "./RememberPasswordComponent.vue?vue&type=script&lang=js"
export * from "./RememberPasswordComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__